import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Stack,
    Typography,
    useMediaQuery
} from '@mui/material';
import UAParser from 'ua-parser-js';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// project imports
import useAuth from 'hooks/useAuth';
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';

// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Google from 'assets/images/icons/social-google.svg';
import Facebook from 'assets/images/icons/social-facebook.svg';
import { DefaultRootStateProps } from 'types';
import CharacterCard from 'ui-component/CharacterCard';
import { Views } from 'features/enumerations';
import { getAppDataStore, ResolvePath, setAppDataStore } from 'features/firebase-app';
import { getUserClaims } from 'features/application/application-slice';
import CacheLoad from './CacheLoad';
export default function PlaywatchGoMobile(props: {}) {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    var parser = new UAParser();
    let browser = parser.getBrowser();
    const claims = useSelector(getUserClaims);
    let navigate = useNavigate();
    let app_location = 'https://apps.apple.com/us/app/playwatch-kids/id1627376574';
    let redirectUrl = getAppDataStore('redirectUrl');
    if (redirectUrl) {
        redirectUrl = `${redirectUrl}?user=${claims.fire_user}`;
    }
    switch (browser.name) {
        case 'Android':
            break;
    }

    return (
        <>
            <img style={{
                position: 'absolute',
                'pointerEvents': 'none',
                width: `100vw`,
                bottom: 141
            }} src={'/login-images/PlaywatchLineup.png'} onLoad={() => {
            }} className={`title-playwatch loaded `} />
            <div style={{
                position: 'absolute',
                width: '100vw',
                top: 'calc(44vh)'
            }}>
                <CacheLoad />
                <Grid container direction="column" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <AnimateButton>
                            <Button
                                disableElevation
                                fullWidth href={app_location}
                                onClick={() => {
                                    window.location.href = app_location;
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: 'grey.700',
                                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                                    borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 20 : theme.palette.grey[100]
                                }}
                            >
                                <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
                                    <PlayArrowIcon />
                                </Box>
                                <span style={{ fontSize: 16 }}>Download the app for free</span>
                            </Button>
                        </AnimateButton>
                    </Grid>
                </Grid>
            </div>
            <div style={{
                position: 'absolute',
                bottom: 0,
                width: '100vw',
                padding: 40
            }}>
                <Grid container direction="column" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <AnimateButton>
                            <Button
                                disableElevation
                                fullWidth
                                href={redirectUrl || `/${(Views)['playwatchkidsmobile']}/${claims.fire_user}`}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: 'grey.700',
                                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                                    borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 20 : theme.palette.grey[100]
                                }}
                            >
                                <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
                                    <PlayArrowIcon />
                                </Box>
                                <span style={{ fontSize: 16 }}>Use Playwatch on your phone or tablet</span>
                            </Button>
                        </AnimateButton>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}